export enum Persona {
  Admin = 'admin',
  Representative = 'advisor',
  Individual = 'account-holder',
  Beneficiary = 'beneficiary',
}
